import React, { CSSProperties, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { faCog } from '@fortawesome/free-solid-svg-icons'

import Modal from '../../../App/Components/Modal/Modal'
import { inlineMediaQuery } from '../../../App/Util'

import { ModalContent } from './Components/ModalContent/ModalContent'
import { SettingButtonWrapper, SettingMenuIcon } from './style'

export const SettingButton = () => {
    const [settingModal, setSettingModal] = useState<boolean>(false)
    const { t } = useTranslation()
    const location = useLocation()

    const currentPath: string = location.search
    const settingsCheck: boolean = currentPath.includes('/settings')
    const mediaBreak = inlineMediaQuery('(max-width: 767px)')
    const title: string = t('Settings')

    useEffect(() => {
        const timer = setTimeout(() => {
            if (currentPath.includes('?home')) {
                setSettingModal(true)
            }
        }, 1000)
        return () => clearTimeout(timer)
    }, [])

    const modalContainerStyle: CSSProperties = {
        transition: 'all 0.2s ease',
        position: `${!mediaBreak ? 'absolute' : 'none'}`,
        bottom: '74px',
        left: '80px',
        width: 'calc(60% - 80px)',
        height: 'fit-content',
        transform: 'none',
        top: 'unset',
        minWidth: '630px',
        maxWidth: '630px',
        zIndex: 150,
    }

    const contentContainerStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'left',
    }

    return (
        <>
            <SettingButtonWrapper
                onClick={() => setSettingModal(!settingModal)}
                isModalOpen={settingModal}
                title={title}
            >
                <SettingMenuIcon icon={faCog} isModalOpen={settingModal} />
            </SettingButtonWrapper>
            <Modal
                modalContainerStyle={modalContainerStyle}
                contentContainerStyle={contentContainerStyle}
                modalState={settingModal}
                setModalState={setSettingModal}
                modalTitle={title}
            >
                <ModalContent />
            </Modal>
        </>
    )
}
